import { Link } from '@inertiajs/react'
import Layout from '../Layout'

interface Account {
  id: number
  name: string
  slug: string
}

interface Customer {
  id: number
  name: string
  email: string
  phone: string
  address: string
  tax_id: string
  city: string
  birth_date: string
  is_wholesale: boolean
}

interface Props {
  customer: Customer
  account: Account
  permissions?: {
    can_manage_customers: boolean
  }
}

function Detail({ label, value }: { label: string; value?: string | null }) {
  return (
    <p>
      <span className="text-gray-500">{label}:</span>{' '}
      <span className="text-[#202020]">{value && value.length > 0 ? value : '—'}</span>
    </p>
  )
}

export default function CustomersShow({ customer, account, permissions }: Props) {
  return (
    <Layout account={account} permissions={permissions}>
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl font-bold text-[#202020] mb-6">
          {customer.name}
          {customer.is_wholesale && (
            <span className="ml-3 inline-block bg-yellow-200 text-yellow-800 text-xs font-semibold px-2.5 py-1 rounded-full">
              Mayorista
            </span>
          )}
        </h1>
        <div className="bg-white p-6 rounded-lg shadow space-y-2">
          <Detail label="Email" value={customer.email} />
          <Detail label="Teléfono" value={customer.phone} />
          <Detail label="RTN" value={customer.tax_id} />
          <Detail label="Ciudad" value={customer.city} />
          <Detail label="Fecha de nacimiento" value={customer.birth_date} />
          <Detail label="Dirección" value={customer.address} />
        </div>
        <div className="mt-4 flex gap-4">
          <Link href={`/${account.slug}/customers/${customer.id}/edit`} className="text-[#55ACEE] hover:underline">Editar</Link>
          <Link href={`/${account.slug}/customers`} className="text-gray-500 hover:underline">Volver a clientes</Link>
        </div>
      </div>
    </Layout>
  )
}
